'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _normalizeOffset = require('./normalizeOffset');

var _normalizeOffset2 = _interopRequireDefault(_normalizeOffset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adjustRegionOffset = function adjustRegionOffset(_ref) {
  var region = _ref.region,
      offset = _ref.offset;

  offset = (0, _normalizeOffset2.default)(offset);

  var newRegion = region.clone();

  if (offset.top) {
    newRegion.addTop(offset.top);
  }

  if (offset.bottom) {
    newRegion.addBottom(-offset.bottom);
  }

  if (offset.left) {
    newRegion.addLeft(offset.left);
  }

  if (offset.right) {
    newRegion.addRight(-offset.right);
  }

  return newRegion;
}; /**
    * Copyright (c) 2015-present, Zippy Technologies
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

exports.default = adjustRegionOffset;